module.exports = __webpack_public_path__ + "img/CLS-P-110.20e225f3.svg";